"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashboardAlertsDataLoaderFactory = void 0;
// (C) 2021 GoodData Corporation
var util_1 = require("@gooddata/util");
var sdk_model_1 = require("@gooddata/sdk-model");
var constants_1 = require("./constants");
var DataLoaderAbstractFactory_1 = require("./DataLoaderAbstractFactory");
// returned in case the backend does not support alerts
var EMPTY_RESPONSE = [];
var DashboardAlertsDataLoader = /** @class */ (function () {
    function DashboardAlertsDataLoader(workspace) {
        this.workspace = workspace;
        this.dashboardAlertsCache = new util_1.LRUCache({ maxSize: constants_1.DASHBOARD_CACHE_SIZE });
    }
    DashboardAlertsDataLoader.prototype.getDashboardAlerts = function (backend, ref) {
        var _this = this;
        // no need to load anything if the backend does not support setting the alerts in the first place
        if (!backend.capabilities.supportsKpiWidget) {
            return Promise.resolve(EMPTY_RESPONSE);
        }
        var cacheKey = sdk_model_1.objRefToString(ref);
        var dashboardAlerts = this.dashboardAlertsCache.get(cacheKey);
        if (!dashboardAlerts) {
            dashboardAlerts = backend
                .workspace(this.workspace)
                .dashboards()
                .getDashboardWidgetAlertsForCurrentUser(ref)
                .catch(function (error) {
                _this.dashboardAlertsCache.delete(cacheKey);
                throw error;
            });
            this.dashboardAlertsCache.set(cacheKey, dashboardAlerts);
        }
        return dashboardAlerts;
    };
    return DashboardAlertsDataLoader;
}());
/**
 * @internal
 */
exports.dashboardAlertsDataLoaderFactory = DataLoaderAbstractFactory_1.dataLoaderAbstractFactory(function (workspace) { return new DashboardAlertsDataLoader(workspace); });
//# sourceMappingURL=DashboardAlertsDataLoader.js.map